export type AdminTheme = 'light' | 'dark';
export const ADMIN_THEME_KEY = 'zipa-admin-theme';

export function readAdminTheme(storage: Pick<Storage, 'getItem'>): AdminTheme {
  try {
    return storage.getItem(ADMIN_THEME_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function saveAdminTheme(storage: Pick<Storage, 'setItem'>, theme: AdminTheme): void {
  try {
    storage.setItem(ADMIN_THEME_KEY, theme);
  } catch {
    // Private browsing/storage limits must not prevent an in-session theme switch.
  }
}
